import { Validator } from 'vee-validate';
import _ from 'lodash';
import VueScrollTo from 'vue-scrollto';

const CURRENCY_DEFAULTS = {
    min: 1,
    max: null,
};

// eslint-disable-next-line import/prefer-default-export
export const lsValidationService = {
    currency: {
        getMessage(name, { min = CURRENCY_DEFAULTS.min, max = CURRENCY_DEFAULTS.max } = {}) {
            let message = `This must be greater or equal to $${min}`;
            if (max) {
                message = `This must be greater than $${min} and less or equal to $${max}`;
            }
            return message;
        },
        validate(value, { min = CURRENCY_DEFAULTS.min, max = CURRENCY_DEFAULTS.max } = {}) {
            const val = value.replace(/[^\d.]/g, '');
            let isValid = val >= min;
            if (isValid && max) {
                isValid = val <= max;
            }
            return isValid;
        },
        params: ['min', 'max'],
    },
    getValidation(type) {
        if (!_.get(this.fields, this.name)) {
            return {};
        }

        const { changed, pristine, touched, invalid } = this.fields[this.name];

        let interactedWith = pristine || touched;
        if (type === 'checkboxes') {
            interactedWith = interactedWith || changed;
        }

        // if the input has been touched and is invalid, we know the user has interacted with it
        // otherwise, if it's pristine and invalid, we know the user has clicked on a submission button
        if (interactedWith && invalid && this.errors.first(this.name)) {
            let message = this.errors.first(this.name);

            // despite identical versions of vee-validate in my. and propertymananger,
            // only the errors in my. have a "." at the end.  No clue why this is, so check
            // for the . and only slice if it's there. Prevents us from having to use a
            // custom dictionary in propertymanager and can share full sentence checks below
            if (message[message.length - 1] === '.') {
                message = message.slice(0, -1);
            }

            // if message includes the string 'field', it is a default validation and we construct a new
            // message here. otherwise, it is a custom error message provided by the above dictionary.
            if (_.includes(message, 'field')) {
                message = `This${message.split('field')[1]}`;
            } else if (
                message === 'The password_new value is not valid' ||
                message === 'The password_confirm value is not valid'
            ) {
                message = 'The passwords do not match';
            } else if (message === 'The account_confirm value is not valid') {
                message = 'The account numbers do not match';
            } else if (message === 'The password_current value is not valid') {
                message = 'This password is incorrect';
            }

            return {
                invalid: true,
                message,
            };
        }

        return {};
    },
    extendVeeValidate() {
        Validator.extend('ls-currency', this.currency);
    },
    scrollToInvalid() {
        const firstInvalidInput = _.get(
            // find the first error label, then get its parent (BField)
            document.getElementsByClassName('help is-error'),
            '[0].parentElement',
            // if not found, just get main wrapping app div
            document.getElementById('app')
        );
        VueScrollTo.scrollTo(firstInvalidInput, 500, {
            // navbar is 74px
            offset: -84,
        });
    },
};
